import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	useEffect(() => {
		function handleResize() {
			if (window.innerWidth > 769 && isMenuOpen) {
				setIsMenuOpen(false);
			}
		}

		window.addEventListener("resize", handleResize);
		handleResize();

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, [isMenuOpen]);

	const menuClass = isMenuOpen ? "hamburgerMenu menuChange" : "hamburgerMenu";
	const buttonClass = isMenuOpen
		? "hamburgerButton change"
		: "hamburgerButton";

	function toggleHamburgerMenu() {
		setIsMenuOpen((prev) => !prev);
	}

	return (
		<>
			<nav id="navigation" className="navbarContainer">
				<div className="navbarIntials">BW</div>
				<div className="navbarNavigationLinks">
					<NavLink to="/" className="link">Home</NavLink>
					<NavLink to="/projects" className="link">Projects</NavLink>
					<NavLink to="/resume" className="link">Resume</NavLink>
					<a href="https://www.linkedin.com/in/bwesson/" className="link">LinkedIn</a>
					<a href="https://github.com/benwesson" className="link">GitHub</a>
				</div>

				<div
					className={buttonClass}
					onClick={toggleHamburgerMenu}
					aria-label="Toggle menu"
				>
					<div className="bar1"></div>
					<div className="bar2"></div>
					<div className="bar3"></div>
				</div>
			</nav>
			<nav
				className={menuClass}
				style={{ height: isMenuOpen ? "250px" : "0px" }}
			>
				<NavLink to="/" className="link">Home</NavLink>
				<NavLink to="/projects" className="link">Projects</NavLink>
				<NavLink to="/resume" className="link">Resume</NavLink>
				<a href="https://www.linkedin.com/in/bwesson/" className="link">LinkedIn</a>
				<a href="https://github.com/benwesson" className="link">GitHub</a>
			</nav>
		</>
	);
}


